var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-box ボタンパネル"},[(_vm.menu)?_c('back-to-menu-button'):_vm._e(),_vm._t("buttons")],2)}
var staticRenderFns = []

export { render, staticRenderFns }